import { createNativeStackNavigator } from "@react-navigation/native-stack";
import InitiateScreen from "./InitiateScreen";
import ConfirmScreen from "./ConfirmScreen";
import SuccessScreen from "./SuccessScreen";

import { headerScreenOptions } from "../../components/HeaderBackButton";
import { ParamList } from "./types";

const Stack = createNativeStackNavigator<ParamList>();

export default function EmailChangeNavigator() {
  return (
    <Stack.Navigator id="email-change" screenOptions={headerScreenOptions}>
      <Stack.Screen name="Initiate" component={InitiateScreen} options={{ title: "Change Login/Contact" }} />
      <Stack.Screen
        name="Confirm"
        component={ConfirmScreen}
        options={{ title: "Verify Email", headerLeft: undefined, headerBackVisible: false }}
      />
      <Stack.Screen name="Success" component={SuccessScreen} options={{ headerShown: false }} />
    </Stack.Navigator>
  );
}
